module.exports = __webpack_public_path__ + "resources/img/logo_entermate.a37761607438d0fe6480e3a750ec59d5.png";